import * as React from 'react'
import GoinZonesPane from '../../../containers/services/GoinZonesPane'
import { RouteComponentProps } from 'react-router-dom'
import { IMap, IZoneObject } from '../../../types/index'
import { withNotification } from '../../ui/notification-provider'

interface IServiceEditZonesProps extends RouteComponentProps {
  onStepSuccessfullyCompleted?: () => void
  formRef: any
  zones: IMap<IZoneObject>
  notification?: any
}

interface IServiceEditZonesState {}

class ServiceEditZones extends React.Component<IServiceEditZonesProps, any> {
  constructor(props: IServiceEditZonesProps) {
    super(props)
  }

  public render() {
    const handleSubmit = () => {
      if (Object.keys(this.props.zones).length > 0) {
        if (this.props.onStepSuccessfullyCompleted) {
          this.props.onStepSuccessfullyCompleted()
        }
      } else {
        const { notification } = this.props
        notification.addNotification({
          title: 'Please create at least one zone!',
          level: 'error'
        })
      }
    }

    const showMessage = (msg: string, isError: boolean) => {
      console.log(msg)
    }

    return (
      <div className='pl2'>
        <div ref={this.props.formRef} onClick={handleSubmit} />
        <div className='font-dark-grey mt3'>Service Zones</div>
        <GoinZonesPane history={this.props.history} showMessage={showMessage} {...this.props} />
      </div>
    )
  }
}

export default withNotification(ServiceEditZones)



// WEBPACK FOOTER //
// ./src/components/services/edit/ServiceEditZones.tsx